export const environment = {
  production: false,
  apiBaseUrl: 'https://tdwalgreensselfservicea-dev-b0edg4cuffgabzeh.northcentralus-01.azurewebsites.net/api',
  azure: {
    clientId: 'ad22f778-8b50-46b5-87a0-b9c87a318f93',
    authority: 'https://wagsoutreach.ciamlogin.com/0f120885-1b2f-4f75-b308-cd66718f9b08',
    redirectUri: 'https://voucherselefserviceui-fjggegepa3eke8ex.northcentralus-01.azurewebsites.net/home',
    apiScope: 'api://6f8a5994-72ce-44a7-8377-3d85e9942e18/access_as_user'
  }
};
